import { httpClient, urlPrefix, makeConfig } from '../data'
/**
 * Get params list
 * @param {*} postId
 * @param {*} typeId
 * @param {*} requestData
 */
export function list(postId, binded = false) {
  let config = makeConfig(postId)
  config.params = {
    binding: !!binded
  }
  return httpClient.http
    .get(`${urlPrefix}/custom-parameters`, config)
    .then(response => {
      return response.data.list
    })
}

/**
 * Get all params list
 * @param {*} postId
 * @param {*} typeId
 * @param {*} requestData
 */
export function listAll(postId) {
  let config = makeConfig(postId)
  return httpClient.http
    .get(`${urlPrefix}/custom-parameters/all`, config)
    .then(response => {
      return response.data.list
    })
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/api/parameters/actions.js